import { IconSvg } from '@utex/ui-kit';
import React from 'react';
import { Avatar, Text, GravatarItem, locked } from './styles';
interface Props {
  email?: string;
  text?: string;
  accountLocked?: boolean;
  onClick?: () => void;
}

export function UserAvatar(props: Props) {
  const { text, email, accountLocked, onClick, ...other } = props;

  return (
    <Avatar email={email} {...other}>
      {email && (
        <GravatarItem email={email} default={'blank'} size={100} data-testid="user-avatar" />
      )}
      {email && text && <Text data-testid="userInitials">{text}</Text>}
      {accountLocked && <IconSvg src="locker" width={11} height={12} css={locked} />}
    </Avatar>
  );
}
